import isAbsoluteURL from 'is-absolute-url';
import normalizeAbsoluteURL from 'normalize-url';
function ensureBaseURL(url, base) {
    url = normalizeURL(url);
    if (typeof base !== 'string') {
        return url;
    }
    base = normalizeURL(base);
    if (base === '/') {
        return url;
    }
    if (isAbsoluteURL(url)) {
        const parsed = new URL(url);
        parsed.pathname = ensureBaseURL(parsed.pathname, base);
        return parsed.href;
    }
    // removes one or more bases (if any)
    url = removeBaseURL(url, base);
    // adds the one base
    url = makeRelativeURL(base, url);
    return url;
}
function extractPathname(url) {
    if (url === undefined || url === null || url === '') {
        return '/';
    }
    if (!isAbsoluteURL(url)) {
        url = toFakeAbsoluteURL(url);
    }
    url = normalizeURL(url);
    const parsed = new URL(url);
    return parsed.pathname;
}
function extractPathnameAndSearch(url) {
    if (url === undefined || url === null || url === '') {
        return '/';
    }
    if (!isAbsoluteURL(url)) {
        url = toFakeAbsoluteURL(url);
    }
    url = normalizeURL(url);
    const parsed = new URL(url);
    return parsed.pathname + parsed.search;
}
function extractURLSearchParams(url) {
    if (url === undefined || url === null || url === '') {
        return new URLSearchParams();
    }
    if (!isAbsoluteURL(url)) {
        url = toFakeAbsoluteURL(url);
    }
    url = normalizeURL(url);
    const parsed = new URL(url);
    return parsed.searchParams;
}
function makeRelativeURL(...parts) {
    parts.unshift('/');
    // ignores undesired types
    parts = parts.filter(part => {
        return typeof part === 'string'
            || typeof part === 'number';
    });
    // converts to string and trims
    parts = parts.map(part => {
        return String(part).trim();
    });
    return normalizeURL(parts.join('/'));
}
function normalizeURL(url) {
    // already absolute, just normalize
    if (isAbsoluteURL(url)) {
        return normalizeAbsoluteURL(url);
    }
    // adds protocol and host to be a parseable URL
    const normalized = normalizeAbsoluteURL(toFakeAbsoluteURL(url));
    const parsed = new URL(normalized);
    // rebuilds relative URL, ignoring temporary protocol and host
    return parsed.pathname + parsed.search;
}
function resolveURL(base, pathname) {
    if (isAbsoluteURL(pathname)) {
        throw new URIError(`Failed to resolve URL. Pathname (${pathname}) cannot be absolute.`);
    }
    base = normalizeURL(base);
    pathname = normalizeURL(pathname);
    if (isAbsoluteURL(base)) {
        const parsed = new URL(pathname, base);
        return parsed.href;
    }
    const parsed = new URL(pathname, toFakeAbsoluteURL(base));
    return extractPathnameAndSearch(parsed.href);
}
function removeBaseURL(url, base) {
    url = normalizeURL(url);
    if (typeof base !== 'string') {
        return url;
    }
    base = normalizeURL(base);
    if (base === '/') {
        return url;
    }
    // unbox, remove, box
    if (isAbsoluteURL(url)) {
        const parsed = new URL(url);
        parsed.pathname = removeBaseURL(parsed.pathname, base);
        return parsed.href;
    }
    // removes one (if any) or more (if duplicated) bases
    while (url.startsWith(base)) {
        url = url.slice(base.length);
    }
    return url;
}
function toFakeAbsoluteURL(pathname) {
    if (isAbsoluteURL(pathname)) {
        throw new URIError(`Failed to create fake absolute URL from ${pathname}. It cannot already be absolute.`);
    }
    return `https://host/${pathname}`;
}
export { ensureBaseURL, extractPathname, extractPathnameAndSearch, extractURLSearchParams, isAbsoluteURL, makeRelativeURL, normalizeURL, removeBaseURL, resolveURL, };
//# sourceMappingURL=url.js.map